import { render } from "./WelcomeStep.vue?vue&type=template&id=3aaa91c4"
import script from "./WelcomeStep.vue?vue&type=script&lang=ts"
export * from "./WelcomeStep.vue?vue&type=script&lang=ts"
script.render = render

export default script